/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import { FindManyCountryDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import { Select } from '@mantine/core'
import { toString } from 'lodash'
import InfinityLoader from './infinityLoader'

const SelectCountry = ({
  onSelect,
  countryId,
  required = true,
  ...etc
}: {
  onSelect: (countryId: string) => void
  countryId?: number
  required?: boolean
  [key: string]: any
}) => {
  const { data: countryData, loading: countryLoading } = useQuery(
    FindManyCountryDocument,
  )

  if (countryLoading) return <InfinityLoader />
  return (
    <Select
      required={required}
      value={toString(countryId)}
      onChange={e => {
        if (e) onSelect(e)
      }}
      searchable
      data={
        countryData?.findManyCountry.map(c => ({
          value: toString(c.id || '-'),
          label: c.name || '-',
        })) || []
      }
      {...etc}
    />
  )
}

export default SelectCountry
